module.exports = __webpack_public_path__ + "img/Frame 109.90edfeb5.png";